/**
 * `/$org/apps/imanage`: the iManage area. This layout reads the person's
 * connection once (IManageArea) and shows the page asked for beneath it:
 * workspaces, a workspace or folder, Search, Recent, Favorites, Saved by
 * Amoreg, or Settings. The area's own sidebar is IManageSidebarNav.
 *
 * @module routes/$org.apps.imanage
 */
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { AppsFrame } from "../components/apps/AppsFrame";
import { IManageArea } from "../components/apps/imanage/IManageArea";

function IManageAreaRoute() {
  const { org: orgSegment } = Route.useParams();
  return (
    <AppsFrame>
      <IManageArea orgSegment={orgSegment}>
        <Outlet />
      </IManageArea>
    </AppsFrame>
  );
}

export const Route = createFileRoute("/$org/apps/imanage")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: IManageAreaRoute,
});
